import WsService from "../WsService";
import Customer from "../../domain/Customer/Customer";


const ENDPOINT_BASE = "/transactions/customer";

export default class CustomerService {

    static retrieveCustomerByUsername(username, basicAuth) {

        let endpoint = ENDPOINT_BASE + "?username=" + username;

        let headers = {
            "Authorization": basicAuth
        }

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new Customer(response);
            },
            response => {
                return response;
            });
    }
}